<script setup lang="ts">

import QueryDataProvider from "./query-data-provider";
import {onMounted, ref, useTemplateRef} from "vue";
import {type DataColumn, TextInput, useClose} from "@hantera/design-system";

const props = defineProps<{
  provider: QueryDataProvider,
  column: DataColumn
}>()

const input = ref(props.column.label)
const inputElem = useTemplateRef<InstanceType<typeof TextInput>>('inputElem')
const close = useClose()

onMounted(() => {
  inputElem.value?.select()
})

function submit() {
  props.provider.setColumnLabel(props.column, input.value)

  close()
}

</script>

<template>
  <form @submit.prevent.stop="submit">
    <TextInput v-model="input" ref="inputElem" />
    <input type="submit" class="button-primary" value="Save" />
  </form>
</template>

<style scoped>

form {
  display: grid;
  grid-template-columns: 1fr min-content;
  gap: 5px;
  min-width: 250px;
}

</style>